//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CenterComponent from "./player/page/center";
import TextComponent from "./player/page/textcomponent";
import Toptextdownpic from "./player/page/toptextdownpic";
import Leftpicrighttext from "./player/page/leftpicrighttext";
import Lefttextrightpic from "./player/page/lefttextrightpic";
import Youtube from "./player/page/Youtube";

export default {
    props: ['url', 'demo', 'starttime', 'repetition'],
    components: {
        Youtube: Youtube,
        Lefttextrightpic: Lefttextrightpic,
        Leftpicrighttext: Leftpicrighttext,
        Toptextdownpic: Toptextdownpic,
        TextComponent: TextComponent,
        CenterComponent: CenterComponent
    },
    data: function data() {
        return {
            item: {
                'options': {}
            },
            audiofile: null,
            pages: [],
            page: [],
            questions: [],
            question: [],
            questions_answers: [],
            answere_checked: [],
            question_index: 0,
            question_return_page: -10,
            question_page: -10,
            page_index: 0,
            question_wrong: false,
            question_right: false,
            qustion_shuffel: false,
            yesno_yes_button_class: 'btn-success',
            yesno_no_button_class: 'btn-danger',
            question_answere_timeout: 1000,
            finished: false
        };
    },
    created: function created() {
        var _this2 = this;

        axios.get(this.url).then(function (res) {
            _this2.item = res.data;
            _this2.pages = _this2.item.pages;
            _this2.showpage();
        }).catch(function (err) {
            console.log(err);
        });
    },
    mounted: function mounted() {},

    methods: {
        showpage: function showpage() {
            if (this.question !== undefined) {
                if (this.question_return_page == this.page_index - 1) {
                    this.page_index = this.question_page;
                }
            }
            this.page = this.pages[this.page_index];

            if (this.audiofile !== null) {
                this.audiofile.pause();
            }

            if (this.page.type === "content") {

                if (this.page.soundfile != null && this.page.soundfile !== '') {
                    this.audiofile = new Audio(this.page.soundfile);
                    var playedPromise = this.audiofile.play();
                    if (playedPromise) {
                        playedPromise.catch(function (e) {
                            if (e.name === 'NotAllowedError' || e.name === 'NotSupportedError') {
                                console.log(e.name);
                            }
                        });
                    }
                }

                var isPageBeforeSuccessPage = this.pages.length > 2 && this.page_index >= this.pages.length - 2 && this.pages[this.page_index + 1].type === "success_page";

                // succeed if we are on the content page before the last page (which is the success page)
                if (!this.item.options.confirm_delivery && isPageBeforeSuccessPage) {
                    this.markSuccess();
                }

                if (this.page.autoplay === true || isPageBeforeSuccessPage) {
                    this.intervalid = setTimeout(this.nextpage, this.page.autoplay_delay * 1000 || 1000);
                } else {
                    clearInterval(this.intervalid);
                }
            } else if (this.page.type === "questiongroup") {
                clearInterval(this.intervalid);

                if (this.page.question_shuffel && this.question_page < 0) {
                    this.questions = this.shuffel(this.page.questions);
                } else {
                    this.questions = this.page.questions;
                }
                if (this.page.question_count > 0) {
                    this.questions = this.page.questions.slice(0, this.page.question_count);
                }
                this.showquestion();
            } else {
                this.page.title = "Erfolgreich";

                if (this.demo) {
                    var _this = this;
                    this.intervalid = setTimeout(function () {
                        _this.page_index = 0;
                        _this.showpage();
                    }, this.page.autoplay_delay * 1000);
                    return;
                }
                if (!this.item.options.confirm_delivery) {
                    this.markSuccess();
                }
            }
        },
        AnswerCorrect: function AnswerCorrect() {
            if (!Array.isArray(this.answere_checked)) {
                if (this.answere_checked.startsWith('false')) {
                    return false;
                } else {
                    return true;
                }
            }
            if (this.question.pointsneeded !== this.answere_checked.length) {
                return false;
            }
            for (var i = 0; i < this.answere_checked.length; i++) {
                if (this.answere_checked[i].startsWith('false')) {
                    return false;
                }
            }
            return true;
        },
        checkAnswer: function checkAnswer(result) {
            var _this3 = this;

            if (result) {
                this.answere_checked = result;
            }
            result = this.AnswerCorrect();

            if (this.questions_answers.length === 0) {
                this.questions_answers[this.page_index] = [{ "id": this.question.id, "selected": this.answere_checked, "result": result }];
            } else {
                var element = this.questions_answers[this.page_index];
                if (element === undefined) {
                    this.questions_answers[this.page_index] = [{ "id": this.question.id, "selected": this.answere_checked, "result": result }];
                } else {
                    var index = element.findIndex(function (f) {
                        return f.id === _this3.question.id;
                    });
                    if (index === -1) {
                        element.push({ "id": this.question.id, "selected": this.answere_checked, "result": result });
                    } else {
                        Vue.set(element, index, {
                            "id": this.question.id,
                            "selected": this.answere_checked,
                            "result": result
                        });
                    }
                }
            }

            if (result) {
                this.question_right = true;
                this.question_index = this.question_index + 1;
                this.question_return_page = 0;
                setTimeout(this.showquestion, this.question_answere_timeout);
            } else {
                this.answere_checked = [];
                this.question_wrong = true;

                //if(!this.item.options.question_go_back){
                setTimeout(this.resetAnswereResult, this.question_answere_timeout);
                return;
                //}

                // TODO: Fix
                //this.question_index = this.question_index + 1;
                //setTimeout(this.showquestion, this.question_answere_timeout) ;
            }
        },
        resetAnswereResult: function resetAnswereResult() {
            var _this4 = this;

            this.question_wrong = false;
            this.question_right = false;

            if (Number(this.question.on_fail) !== 0) {
                this.question_page = this.page_index;

                this.page_index = this.pages.findIndex(function (t) {
                    return t.id === Number(_this4.question.on_fail);
                });
                if (Number(this.question.return_page) === 0) {
                    this.question_index = 0;
                    this.question_page = 0;
                } else {
                    this.question_return_page = this.pages.findIndex(function (t) {
                        return t.id === Number(_this4.question.return_page);
                    });
                }

                this.showpage();
            }
        },
        showquestion: function showquestion() {
            var _this5 = this;

            this.question_wrong = false;
            this.question_right = false;
            this.answere_checked = [];

            this.question = this.questions[this.question_index];

            this.yesno_yes_button_class = 'btn-success';
            this.yesno_no_button_class = 'btn-danger';

            if (this.questions_answers[this.page_index] !== undefined && this.question !== undefined) {
                var selected = this.questions_answers[this.page_index].filter(function (answer) {
                    return answer.id == _this5.question.id;
                });
                if (selected.length > 0) {
                    this.answere_checked = selected[0].selected;

                    if (this.question.type === 'yesno') {
                        this.yesno_yes_button_class = 'btn-secondary';
                        this.yesno_no_button_class = 'btn-secondary';
                        if (selected[0].result) {
                            this.yesno_yes_button_class = 'btn-primary';
                        } else {
                            this.yesno_no_button_class = 'btn-primary';
                        }
                    }
                }
            }

            if (this.question === undefined) {
                this.question_index = 0;
                this.nextpage();
                return;
            }

            if (this.audiofile !== null) {
                this.audiofile.pause();
            }

            if (this.question.soundfile != null && this.question.soundfile !== '') {
                this.audiofile = new Audio(this.question.soundfile);
                this.audiofile.play();
            }
        },
        nextpage: function nextpage() {
            var i = 1;

            if (this.repetition) {
                while (this.pages[this.page_index + i].type === 'questiongroup') {
                    i = i + 1;
                }
            }

            this.page_index = this.page_index + i;
            if (this.page_index >= this.pages.length) {
                this.page_index = this.page_index - 1;
            }
            this.showpage();
        },
        backpage: function backpage() {
            var i = -1;

            if (this.repetition) {
                while (this.pages[this.page_index + i].type === 'questiongroup') {
                    i = i - 1;
                }
            }

            if (this.item.options.question_go_back) {
                this.page_index = this.page_index + i;
                this.showpage();
                return;
            }

            if (this.page.type !== "questiongroup") {
                this.page_index = this.page_index + i;
                if (this.pages[this.page_index].type === "questiongroup") {

                    this.question_index = this.pages[this.page_index].questions.length + i;
                }
            } else {
                if (this.question_index > 0) {
                    this.question_index = this.question_index + i;
                } else {
                    this.question_index = 0;
                    this.page_index = this.page_index + i;
                }
                this.question = undefined;
            }
            this.showpage();
        },
        shuffel: function shuffel(array) {
            var counter = array.length,
                temp,
                index;
            // While there are elements in the array
            while (counter > 0) {
                // Pick a random index
                index = Math.floor(Math.random() * counter);

                // Decrease counter by 1
                counter--;

                // And swap the last element with it
                temp = array[counter];
                array[counter] = array[index];
                array[index] = temp;
            }
            return array;
        },
        markSuccess: function markSuccess() {
            if (this.repetition || this.finished) {
                return;
            }

            var _this = this;
            var postData = this.questions_answers.filter(function (val) {
                return val !== undefined && val !== null;
            });

            axios.post('/de/training/mark/success', {
                "result": postData,
                "starttime": this.starttime
            }).then(function (response) {

                if (_this.item.options.show_certificate) {
                    window.open("/certificate/" + response.data.training, "", "_blank");
                }
                if (_this.item.options.success_page_forwarding !== "" && _this.item.options.success_page_forwarding !== null) {
                    window.location.href = _this.item.options.success_page_forwarding;
                }

                _this.finished = true;
            }).catch(function (error) {
                swal({
                    title: i18n.messages.error,
                    html: i18n.messages.error,
                    type: 'error'
                });
            });
        },
        roundInput: function roundInput() {
            if (this.question === undefined) {
                return;
            }
            if (this.question.type !== 'input') {
                return;
            }
            if (this.question.question_input_type !== 'number') {
                return;
            }
            this.answere_checked = parseFloat(this.answere_checked).toFixed(this.question.decimal_places);
        }
    },
    computed: {
        cangoBack: function cangoBack() {

            if (this.page_index === 0) {
                return false;
            }

            if (this.item.options.question_go_back) {
                if (this.pages[this.page_index - 1].type === "questiongroup") {
                    return false;
                }
            }
            return true;
        },
        cangoNext: function cangoNext() {
            if (this.pages.length < this.page_index) {
                return false;
            }
            if (this.pages[this.page_index + 1] === undefined) {
                return false;
            }
            return true;
        },
        Answers: function Answers() {
            if (this.question.answere_shuffel) {
                return this.shuffel(this.question.answers);
            } else {
                return this.question.answers;
            }
        },
        allQuestionAnsweres: function allQuestionAnsweres() {
            var allQuestionAnsweres = [];

            this.question.answers.forEach(function (answere) {
                if (!allQuestionAnsweres.includes(answere.answere.trim())) {
                    allQuestionAnsweres.push(answere.answere.trim());
                }
            });

            return this.shuffel(allQuestionAnsweres);
        },
        CountCorrectAnswer: function CountCorrectAnswer() {
            return this.question.answers.filter(function (answere) {
                return answere.value == true;
            }).length;
        },
        input_step: function input_step() {
            switch (this.question.decimal_places) {
                case "0":
                    return 1;
                    break;
                case "1":
                    return 0.1;
                case "2":
                    return 0.01;
                case "3":
                    return 0.001;
            }
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]]}!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/js/components/Player.vue
// module id = 44
// module chunks = 0